import styled from 'styled-components';
import bgArrow from '../../../assets/arrow-double.svg';

export const CreateListStyle = styled.div`
  position: relative;

  .content-holder {
    overflow: hidden;
    max-width: 780px;
    padding: 40px 15px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
  }

  .head {
    width: 100%;
    font-size: 16px;
    line-height: 20px;
    margin: 0 0 25px;
    color: #9d9d9d;

    .title {
      display: block;
      font-size: 25px;
      line-height: 28px;
      font-weight: 500;
      margin: 0 0 10px;
      color: #313131;
    }
  }

  .filter-holder {
    position: relative;
    padding: 30px 0;

    .subtitle {
      display: block;
      font-size: 20px;
      line-height: 24px;
      font-weight: 500;
      text-transform: capitalize;
      margin: 0 0 20px;
      color: #313131;
    }
  }

  .holder {
    margin: 0 0 5px;
  }

  .choose-col {
    position: relative;
    z-index: 1;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      height: 1px;
      background: #d9d9d9;
      z-index: -1;
    }

    .wrap {
      display: flex;
      align-items: center;
      gap: 10px;
      position: relative;
      max-width: 300px;
      margin: 8px auto 24px;
      padding: 2px;
      border: 1px solid #dedede;
      border-radius: 50px;
      background: #fbfbfb;
      z-index: 1;
    }

    .btn-text {
      display: block;
      flex-grow: 1;
      font-size: 14px;
      line-height: 18px;
      text-transform: uppercase;
      text-align: center;
      padding: 5px;
      border-radius: 50px;

      &.active {
        color: #fff;
        background: #317bff;
      }
    }
  }

  .select-row {
    display: grid;
    grid-template-columns: 1fr 1fr 1.2fr;
    gap: 10px;
    position: relative;
    z-index: 2;
    padding: 0 30px 0 0;

    &.active {
      z-index: 5;
    }

    .react-select__control {
      padding-left: 10px;
      padding-right: 10px;
    }
    .react-select__indicator {
      padding: 0;
      width: 9px;
      height: 13px;
      background-image: url(${bgArrow});
      background-repeat: no-repeat;
      background-size: cover;

      svg {
        display: none;
      }
    }
    .react-select__clear-indicator {
      display: none;
    }
  }

  .btn-delete {
    position: absolute;
    top: 10px;
    right: 0;
    font-size: 18px;
    line-height: 1;
    color: #b2b2b2;
    transition: all 0.3s ease;

    &:hover {
      color: var(--danger);
    }
  }

  .btn-add-filter {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    font-size: 14px;
    line-height: 16px;
    font-weight: 600;
    color: #317bff;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #317bff;
  }

  .btn-holder {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 15px;
    border-top: 1px solid #e6e7ec;
    background: var(--white);

    &::before {
      display: none;
      content: '';
      position: absolute;
      bottom: 100%;
      left: 0;
      right: 0;
      height: 80px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #f4f4f4 100%);
    }

    .btn-wrap {
      display: flex;
      gap: 10px;
      width: 100%;
      max-width: 300px;
    }

    .total-leads {
      max-width: 350px;
      font-size: 14px;
      line-height: 18px;
      color: #317bff;
      padding: 10px 20px;
      border-radius: 50px;
      background: rgba(49, 123, 255, 0.1);

      strong {
        font-weight: 600;
      }

      .btn-preview {
        display: inline-block;
        text-decoration: underline;
        color: #317bff;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
`;
